import mapFunction from './mapResources';

export default mapFunction('buildings', {
    isFetching: false,
    items: [] 
});
